<template>
  <div class="industyNews">
    <div class="body-content">
      <div class="breadcrumb-box">
        <div class="breadcrumb-body">
          <span class="pointer" @click="toHome">首页</span>
          <span>>></span>
          <span>成果概览</span>
        </div>
      </div>
      <div class="title">成果概览</div>
      <div class="search-box">
        <input type="text" placeholder="请输入相关字段，点击搜索">
        <span class="search-btn">搜索</span>
      </div>
      <div class="show-list"
        v-for="(item1, index1) in data"
        :key="index1"
      >
        <div class="name">{{item1.title}}</div>
        <ul>
          <li
            v-for="(item2, index2) in item1.list"
            :key="index2"
          >
            <span class="text pointer">{{item2.name}}</span>
            <span class="date">{{item2.date}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: [
        {
          title: '标准样品',
          list: [
            {
              name: '国家标准样品《牛肉蛋白中碳稳定同位素标准样品 GSB 11-3647-2019》',
              date: '12-23'
            },
            {
              name: '国家标准样品《牛肉蛋白中氮稳定同位素标准样品 GSB 11-3646-2019》',
              date: '11-23'
            },
            {
              name: '枯草芽孢杆菌等微生物菌剂标准样品',
              date: '11-23'
            },
            {
              name: '巨大芽孢杆菌等微生物菌剂标准样品',
              date: '11-23'
            },
            {
              name: '《天麻苷元标准样品》',
              date: '10-23'
            }
          ]
        },
        {
          title: '计量基标准',
          list: [
            {
              name: '石墨烯特性参数测量标准装置',
              date: '12-23'
            },
            {
              name: '高性能电工钢材料动态磁性计量标准装置',
              date: '11-23'
            },
            {
              name: '永磁材料磁参数现场计量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '10-23'
            }
          ]
        },
        {
          title: '国内标准',
          list: [
            {
              name: '石墨烯特性参数测量标准装置',
              date: '12-23'
            },
            {
              name: '高性能电工钢材料动态磁性计量标准装置',
              date: '11-23'
            },
            {
              name: '永磁材料磁参数现场计量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '10-23'
            },
            {
              name: '石墨烯特性参数测量标准装置',
              date: '12-23'
            },
            {
              name: '高性能电工钢材料动态磁性计量标准装置',
              date: '11-23'
            },
            {
              name: '永磁材料磁参数现场计量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '10-23'
            }
          ]
        },
        {
          title: '软件系统',
          list: [
            {
              name: '石墨烯特性参数测量标准装置',
              date: '12-23'
            },
            {
              name: '高性能电工钢材料动态磁性计量标准装置',
              date: '11-23'
            },
            {
              name: '永磁材料磁参数现场计量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '10-23'
            }
          ]
        },
        {
          title: '研究报告',
          list: [
            {
              name: '石墨烯特性参数测量标准装置',
              date: '12-23'
            },
            {
              name: '高性能电工钢材料动态磁性计量标准装置',
              date: '11-23'
            },
            {
              name: '永磁材料磁参数现场计量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '11-23'
            },
            {
              name: '微纳薄膜材料结构光散射测量标准装置',
              date: '10-23'
            }
          ]
        }
      ]
    }
  },
  methods: {
    toHome () {
      this.$router.push('/')
    }
  }
}
</script>

<style lang="less" scoped>
.body-content {
  width: @body-width;
  margin: 0 auto;
}
.industyNews {
  .breadcrumb-box {
    margin-bottom: 24px;
    padding-top: 12px;
    .breadcrumb-body {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 17px;
      span {
        margin-right: 7px;
      }
    }
  }
  .title {
    margin-bottom: 32px;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
    color: rgba(0, 0, 0, 0.65);
    text-align: center;
  }
  .search-box {
    display: flex;
    margin-bottom: 32px;
    padding-left: 60px;
    input {
      margin-right: 24px;
      width: 980px;
      height: 52px;
      outline: none;
      border: 1px solid rgba(0, 0, 0, 0.1);
      padding-left: 26px;
      box-sizing: border-box;
    }
    .search-btn {
      width: 120px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      background-color: rgba(46, 92, 154, 1);
      cursor: pointer;
    }
  }
  .show-list {
    padding-bottom: 32px;
    &:last-child {
      padding-bottom: 60px;
    }
    .name {
      display: inline-block;
      margin-bottom: 16px;
      padding-bottom: 6px;
      font-size: 18px;
      font-weight: 700;
      line-height: 25px;
      color: rgba(46, 92, 154, 1);
      border-bottom: 2px solid rgba(46, 92, 154, 1);
    }
    ul {
      display: flex;
      flex-direction: column;
      padding-left: 16px;
      box-sizing: border-box;
      li {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 42px;
        padding-left: 13px;
        border-bottom: 1px solid rgba(216, 216, 216, .49);
        box-sizing: border-box;
        &::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 0;
          z-index: 1;
          transform: translateY(-50%);
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: rgba(46, 92, 154, 1);
        }
        .text {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.85);
        }
        .date {
          font-size: 14px;
          color: rgba(143, 143, 143, 1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/industyNews/index.vue